import {MoveMoney} from '@client/models/store/movemoney';
import {Logger, Category} from '@simpleinvest/front-end-logger';
// eslint-disable-next-line import/no-cycle
import transferService from '@client/services/transfers';

const logger = new Logger({
  category: Category.TransferMoney,
  fileName: 'movemoney.js',
});

const stateObj = () => new MoveMoney();

const actions = {
  async getPlaidConfig({commit, rootGetters}) {
    const client = rootGetters['user/userFullName'];
    const result = await transferService.getPlaidConfig();
    const plaidConfigObj = {
      ...result.data.data,
      client,
    };

    commit('SET_PLAID_CONFIG', plaidConfigObj);

    return plaidConfigObj;
  },

  async getMicroDeposit({commit, rootGetters}) {
    try {
      const result = await transferService.getMicroDeposit({clUserId: rootGetters['cognitoUser/userId']});

      commit('SET_MICRODEPOSITLIST', result);
    } catch (error) {
      logger.addBreadcrumb({
        callingFuncName: 'getMicroDeposit',
        message: `getMicroDeposit error caught`,
      });
      logger.logException({error});
    }
  },
  async cancelMicroDeposit({dispatch}, payload) {
    try {
      await transferService.cancelMicroDeposit(payload);

      await dispatch('getMicroDeposit');
    } catch (error) {
      logger.addBreadcrumb({
        callingFuncName: 'cancelMicroDeposit',
        message: `cancelMicroDeposit error caught`,
      });
      logger.logException({error});
    }
  },
  async verifyManualMicroDeposit(_, payload) {
    try {
      await transferService.verifyManualMicroDeposit({microDepositId: payload});
    } catch (error) {
      logger.addBreadcrumb({
        callingFuncName: 'verifyManualMicroDeposit',
        message: `Error manually verifying micro-deposit.`,
      });
      logger.logException({error});

      throw error;
    }
  },
};
const mutations = {
  SET_PLAID_CONFIG(state, payload) {
    state.apiVersion = payload.apiVersion;
    state.client = payload.client;
    state.environment = payload.environment;
    state.robustPublicKey = payload.robustPublicKey;
  },
  SET_MICRODEPOSITLIST(state, payload) {
    state.isMicroDepositListLoaded = true;
    state.microDepositList = payload;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  actions,
  mutations,
};
